import { computed, watch } from 'vue'
import { useStore } from 'vuex'

export function usePageTitle() {
  const store = useStore()

  // Вычисляем заголовок страницы
  const pageTitle = computed(() => {
    const translatePage = store.state.i18n.translatePage;
    if (translatePage === null) {
      return 'Hleb Studio';
    }
    if (translatePage.breadCrumbs === null) {
      return 'Hleb Studio';
    }
    if (translatePage.breadCrumbs.title === null) {
      return 'Hleb Studio';
    }

    return translatePage.breadCrumbs.title;
  })

  // Функция для установки заголовка документа
  const setDocumentTitle = (title: string) => {
    document.title = title;
  }

  // Следим за изменением заголовка и обновляем document.title
  watch(pageTitle, (newTitle) => {
    if (newTitle) {
      setDocumentTitle(newTitle as string)
    }
  }, { immediate: true })

  return {
    pageTitle,
    setDocumentTitle,
  }
}